import { useThemeContext } from '#contexts/ThemeContext';
import { Box, Checkbox, FormControl, makeStyles, Typography } from '@material-ui/core';
import { CheckOutlined } from '@material-ui/icons';

import { Field } from '#models/questionnaire';
import { useLeadField } from '#modules/LeadGeneration/hooks/field';
import { colors } from '@swyft/ui';
import * as React from 'react';

interface CheckBoxFieldProps {
  field: Field;
  handleChangeFields?: (id: string, value: any) => void;
}

export const CheckBoxField = ({ field, handleChangeFields }: CheckBoxFieldProps) => {
  const [formField, { error, touched }, { setValue }] = useLeadField(field);
  const classes = useStyles();

  return (
    <React.Fragment>
      <FormControl>
        <Box width='100%' display='flex' alignItems='flex-start'>
          <Checkbox
            color='primary'
            {...formField}
            onChange={(e) => {
              setValue(`${e.target.checked}`);
              if (handleChangeFields) handleChangeFields(field.id as string, `${e.target.checked}`);
            }}
            checked={formField.value === 'true'}
            style={{ padding: '0px 0.625rem' }}
            className={classes.checkbox}
            checkedIcon={<CheckOutlined />}
          />
          <div
            className={classes.checkboxCustom}
            dangerouslySetInnerHTML={{
              __html: `<span>${field?.checkBoxText}</span>`
            }}
          />
        </Box>
      </FormControl>
      {error && touched && (
        <Typography variant='subtitle2' color='error'>
          {error}
        </Typography>
      )}
    </React.Fragment>
  );
};

const useStyles = () => {
  const { linkText, primaryButtonBackground } = useThemeContext();

  return makeStyles({
    checkboxCustom: {
      '& a': {
        textDecoration: 'none',
        color: linkText,
        fontWeight: 600
      }
    },
    checkbox: {
      '&.MuiCheckbox-colorPrimary.Mui-checked': {
        '& .MuiSvgIcon-root': {
          backgroundColor: primaryButtonBackground,
          width: 18,
          height: 18,
          borderRadius: 3
        },
        color: colors.white,
        width: 44,
        height: 24,
        '&:hover': {
          color: colors.white
        }
      },
      '&.MuiCheckbox-colorPrimary:hover': {
        color: primaryButtonBackground
      }
    }
  })();
};
